function buildDonation(transformed, mission) {
  if (!mission.donation) {
    return transformed;
  }

  transformed.live_mode = mission.donation.live_mode;
  transformed.is_donation_eligible = mission.donation.eligible;
  transformed.donation_attribute = mission.donation.attributes;
  transformed.donation_statistics = mission.donation.statistics;

  return transformed;
};

function buildVolunteering(transformed, mission) {
  if (!mission.volunteering) {
    return transformed;
  }

  transformed.achieved_goal = mission.volunteering.achieved_goal;
  transformed.is_virtual = mission.volunteering.virtual || false;
  transformed.mission_rating_count = mission.volunteering.average_rating || 0;
  transformed.seats_left = mission.seats_left || mission.volunteering.seats_left;
  transformed.goal_objective = mission.volunteering.goal_objective || 0;
  transformed.application_deadline = mission.volunteering.deadline || null;
  transformed.user_application_count = mission.volunteering.is_applied || false;

  return transformed;
};

function buildTeam(transformed, mission) {
  if (!mission.team) {
    return transformed;
  }

  transformed.only_teams = mission.team.only_teams;
  transformed.allow_team_volunteering = mission.team.eligible;

  return transformed;
};

/**
 * Since we still use (time|number-of-changes|complexity) old components that needed refactoring
 * this will convert refactored endpoint format into the old format
 * for backward compatibility
 */
export default function (mission, lang) {
  const theme = mission.theme ? mission.theme.name : null;

  let transformed = {
    ...mission,
    default_media_id: mission.default_media.id,
    default_media_type: mission.default_media.type,
    default_media_path: mission.default_media.path,
    organization: {
      organization_id: mission.organization.id,
      name: mission.organization.name
    },
    mission_theme: {
      theme_name: theme,
      translations: [
        {
          lang,
          title: theme
        }
      ]
    },
    matching_gift: mission.matching_gift,
    city_name: mission.city
      ? mission.city.name
      : null,
    skill: mission.skills ? mission.skills.map(skill => ({
      id: skill.id,
      title: skill.name
    })) : null,
    is_favourite: mission.is_favorite,
    mission_rating_total_volunteers: mission.ratings_total || 0
  }

  transformed = buildTeam(transformed, mission);
  transformed = buildDonation(transformed, mission);
  transformed = buildVolunteering(transformed, mission);

  return transformed;
};